export const ADYEN_ERROR_GENERAL_NOTIFICATION = 'Please contact your card issuer for more details or try with a different card.';
export const ADYEN_ERROR_PAYPAL_NOTIFICATION = 'Please contact PayPal for more details or try with a different payment method.';
